import { render, staticRenderFns } from "./MediaGalleryImage.vue?vue&type=template&id=e053024c&scoped=true&lang=pug&"
import script from "./MediaGalleryImage.vue?vue&type=script&setup=true&lang=js&"
export * from "./MediaGalleryImage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MediaGalleryImage.vue?vue&type=style&index=0&id=e053024c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e053024c",
  null
  
)

export default component.exports